export enum EDownloadReportType {
  /**
   * Maestro de Usuarios
   */
  USER_MASTER = 1,
  /**
   * Auditoría de Pedidos
   */
  ORDER_AUDIT = 2,
  /**
   * Dispositivos Bloqueados
   */
  BLOCKED_DEVICES = 3,
}

/**
 * Download Report Status Enum defined in the backend
 */
export enum EDownloadReportStatus {
  /**
   * `Descarga pendiente`
   */
  PENDING = 10,
  /**
   * `Descarga lista`
   */
  COMPLETED = 11,
  /**
   * `Descarga fallida`
   */
  FAILED = 12,
}
